import React from "react";
import './App.css';
import {Link} from 'react-router-dom';

function Nav() {
    return (
       <nav>
           <h3 style={{float: "left"}}><a href="https://kardandon.github.io">Emre Küçükkaya </a></h3>
           <ul className="nav-links">
               <li className="nav-links-list"> <a href="https://github.com/kardandon">About </a></li>
           </ul>
       </nav> 
    )
}

export default Nav;